/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

interface TableHeadRowProps {
  sort?: string
  sortDir?: 'asc' | 'desc'
  onSort?: (sortName: string, sortDir: 'asc' | 'desc') => void
  children?: React.ReactNode
  classNames?: string
}

const TableHeadRow: React.FC<TableHeadRowProps> = ({ sort, sortDir, onSort, children, classNames }) => {
  return (
    <tr className={classNames}>
      {children &&
        React.Children.map(children, (child) => {
          if (!React.isValidElement(child)) return child

          const childProps = child.props as any

          if (childProps.sort) {
            return React.cloneElement(child as any, {
              key: childProps.sort || childProps.id,
              isCurrent: childProps.sort && sort === childProps.sort,
              sortDir: sortDir,
              // Pass a function that will be called on click with the direction
              // This wrapper ensures onSort is only called when user clicks, not during render
              onSort: onSort ? (dir: 'asc' | 'desc') => onSort(childProps.sort, dir) : undefined
            })
          } else {
            return React.cloneElement(child as any, {
              key: childProps.id
            })
          }
        })}
    </tr>
  )
}

export default TableHeadRow
